import Konva from 'konva';
import {
  DROP_ZONE_COLOR,
  DROP_ZONE_HOVER_COLOR,
  DROP_ZONE_SCALE,
  DROP_ZONE_HOVER_SCALE,
  SEAT_EMPTY_COLOR,
  SEAT_OCCUPIED_COLOR
} from '../constants.ts';

export function showDropZones(stage: Konva.Stage, occupied: Set<string>, originalSeatKey: string | null) {
  stage.find('.seat').forEach(seat => {
    const key = `${seat.attrs.tableNumber}-${seat.attrs.seatNumber}`;
    const isCandidate = !occupied.has(key) || key === originalSeatKey;
    if (isCandidate) {
      seat.to({ fill: DROP_ZONE_COLOR, scaleX: DROP_ZONE_SCALE, scaleY: DROP_ZONE_SCALE, duration: 0.2 });
    }
  });
}

export function resetDropZones(stage: Konva.Stage, occupied: Set<string>) {
  stage.find('.seat').forEach(seat => {
    const key = `${seat.attrs.tableNumber}-${seat.attrs.seatNumber}`;
    const occupiedNow = occupied.has(key);
    seat.to({
      scaleX: 1,
      scaleY: 1,
      fill: occupiedNow ? SEAT_OCCUPIED_COLOR : SEAT_EMPTY_COLOR,
      duration: 0.2
    });
  });
}

export function setHoverSeat(seat: Konva.Shape | null) {
  if (!seat) return;
  seat.to({ fill: DROP_ZONE_HOVER_COLOR, scaleX: DROP_ZONE_HOVER_SCALE, scaleY: DROP_ZONE_HOVER_SCALE, duration: 0.1 });
}
